import apiClient from '../../../shared/config/axios'
import { MailSettingResponse, UpdateMailSettingDto } from '@myapp/contract'

export const mailSettingsApi = {
  get: () => apiClient.get<MailSettingResponse>('/mail-settings'),
  update: (data: UpdateMailSettingDto) =>
    apiClient.put<MailSettingResponse>('/mail-settings', data),
  test: () => apiClient.post<{ ok: true }>('/mail-settings/test'),
}
